import classnames from 'classnames';
import cooperationSDK from 'lib/cooperationSdk';
import React from 'react';

import styles from './index.module.scss';

interface IProps {
  headerRender?: React.ReactNode
};

const TitlePanel: React.FC<IProps> = (props) => {
  const { headerRender, children } = props;
  return (<div className={classnames(styles.container, cooperationSDK.isCoEnv ? styles.co : null)}>
    <div className={styles.header}>
      {headerRender}
    </div>
    {children}
  </div>);
};

export default TitlePanel;
